// Admin-only per-key descriptions for account server config. Env-independent.
// NOT persisted to KV/D1 and NOT read by runtime code — shown in the admin config table.
export const serverDescription = {
    configPollIntervalMs: 'how often the server re-checks the D1 config hash (ms)',
    mlScaleUpHoldSec: 'ML autoscaler: seconds the backlog must stay above target before scaling up (all pools)',
    mlScaleDownHoldSec: 'ML autoscaler: seconds the backlog must stay below target before scaling down (all pools)',
    mlTargetBacklogImageEmbedding: 'ML autoscaler: waiting jobs per instance for the image embedding pool (siglip2)',
    mlTargetBacklogImageModeration:
        'ML autoscaler: waiting jobs per instance for the image moderation pool (nudenet-image)',
    mlTargetBacklogTextModeration:
        'ML autoscaler: waiting jobs per instance for the text moderation pool (bert-small-toxicity)',
    mlTargetBacklogVideoModeration:
        'ML autoscaler: waiting jobs per instance for the video moderation pool (nudenet-video; 1 = one box per waiting video)',
    mlTargetWaitMinImageEmbedding:
        'ML autoscaler: minutes the waiting jobs of the image embedding pool (siglip2) should take to clear (jobs per instance = measured calls per minute x this; mlTargetBacklog* applies when nothing can be measured)',
    mlTargetWaitMinImageModeration:
        'ML autoscaler: minutes the waiting jobs of the image moderation pool (nudenet-image) should take to clear (see mlTargetWaitMinImageEmbedding)',
    mlTargetWaitMinTextModeration:
        'ML autoscaler: minutes the waiting jobs of the text moderation pool (bert-small-toxicity) should take to clear (see mlTargetWaitMinImageEmbedding)',
    mlTargetWaitMinVideoModeration:
        'ML autoscaler: minutes the waiting jobs of the video moderation pool (nudenet-video) should take to clear (see mlTargetWaitMinImageEmbedding)',
};
